import { Route, RouteObject } from "react-router-dom";
import NewListForm from "./components/NewList/NewListForm";
import { Lists } from "./components/ListsLanding/ListsLanding";

export interface uxListsRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: uxListsRoute[];
}

export const uxListsRoutes: uxListsRoute[] = [
  {
    path: "communication-hub/lists",
    element: <Lists />,
  },
  {
    path: "communication-hub/lists/new",
    element: <NewListForm />,
  },
  {
    path: "communication-hub/lists/:action/:id",
    element: <NewListForm />,
  },
];
